import { Injectable, signal } from '@angular/core';
import { TenantPermissions, UserDetailDto, UserService } from '@artemis-software/wr-api';
import { AuthService } from '@services/auth.service';
import { firstValueFrom } from 'rxjs';

export type Permission = keyof TenantPermissions

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {

  readonly currentUser = signal<UserDetailDto | undefined | null>(undefined);

  constructor(
    private readonly userService: UserService,
    private readonly authService: AuthService,
  ) {
    this.authService.loggedIn$.subscribe(async () => {
      await this.waitForUser();
    });
    this.authService.loggedOut$.subscribe(() => {
      this.currentUser.set(null);
    });
  }

  async waitForUser(): Promise<UserDetailDto | null> {
    const current = this.currentUser();
    if (!current) {
      const user = await this.getCurrentUser();
      this.currentUser.set(user);
      return user;
    }
    return current;
  }

  async getCurrentUser() {
    try {
      return await firstValueFrom(this.userService.findCurrentUser());
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  hasPrivilege(permission: Permission): boolean {
    return this.currentUser()?.tenant.permissions[permission] ?? false;
  }

  // Contractors regelt weiterhin allein der BuildingTgas-Scope
  canViewTgas(): boolean {
    const tenantType = this.currentUser()?.tenantType;
    if (!tenantType) {
      return false;
    }
    if (tenantType === UserDetailDto.TenantTypeEnum.Contractor) {
      return true;
    }
    return this.hasPrivilege(tenantType === UserDetailDto.TenantTypeEnum.Internal ? 'viewInternalTgas' : 'viewExternalTgas');
  }
}
